<template>
  <div>

    <!-- page-heading -->
    <page-heading pageTitle="APOPOINT-CONTROL_CENTER" :showBack="false"></page-heading>

    <tabs type="boxed" size="normal" :on-tab-click="changeTab" :active-index="activeTab">
      <tab-item v-for="tab in activeTabs" :label="$t(tab.name)" :key="$route.path">
        <router-view :name="tab.name" :key="$route.path"></router-view>
      </tab-item>
    </tabs>
  </div>


</template>



<script>
export default {

    name: 'pimSettings',

	data() {

		return {
      activeTab: 0,
        tabs: [
          { name: 'APOPOINT-CC-TAB-START', route: 'apopointCCStart', active: true },
          // { name: 'PIM-SETTINGS-TAB-SHOPIX', route: 'pimSettingsShopix', active: true },
          // { name: 'POPOINT-CC-TAB-2', route: 'apopointCC2', active: true },
        ]
      }

    },

    computed: {

      activeTabs() {
        return this.tabs.filter(t => t.active == true);
      }
    },

    created() {

      // this.activeTab = this.$route.name == 'pimSettingsShopix' ? 1 : 0;
      this.activeTab = this.$route.name == 'pimSettingsSisix' ? 1 : 0;

    },

    methods: {

      changeTab(tab) {

        if(tab != this.activeTab) {
          this.activeTab = tab;
          this.$router.push({ name: this.tabs[tab].route} );
        }

      }
    }

}

</script>



<style lang="scss" scoped>

    .tabs {

        .tab-content {

            .tab-pane {

                line-height: 1.2rem;

                a {
                    display: inline;
                    border: none;
                    padding: 0;
                    border-radius: 0;

                    &:hover {
                        background: none;
                    }
                }
            }

        }


    }


</style>
